import classNames from 'classnames';
import React, { useState } from 'react';
// import moment from "moment";
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Button } from '@myhealth-raccoon/components';

import { SearchResults } from 'src/components/telehealth';
// import { useOpenApp } from "src/hooks/useOpenApp";
import { StateEnum, TelehealthAvailableRequest } from 'src/services/telehealth';

export function SearchResultsScreen() {
    const [search] = useSearchParams();
    // const { openApp } = useOpenApp();
    const [sortBy, setSortBy] = useState<'Nearest' | 'Earliest'>('Nearest');

    const telehealthQuery: TelehealthAvailableRequest = useMemo(
        () => ({
            state:
                search.has('state') && sortBy === 'Nearest'
                    ? StateEnum[search.get('state') as keyof typeof StateEnum]
                    : undefined,
            gender: search.get('gender') ?? undefined,
            language: search.has('language') ? search.getAll('language') : undefined,
        }),
        [search, sortBy]
    );

    return (
        <main className="bg-white py-6">
            <div className="container">
                <div className="flex flex-row flex-wrap items-center justify-between gap-4">
                    <h2 className="text-xl font-medium text-gray-900">
                        {search.has('suburb') ? (
                            <>
                                Book a Telehealth Appointment near{' '}
                                <span className="text-primary">
                                    {search.get('suburb')} {search.get('postcode')}
                                </span>
                            </>
                        ) : (
                            'Book a Telehealth Appointment'
                        )}
                    </h2>
                    <div className="flex flex-row">
                        <Button
                            onClick={() => setSortBy('Nearest')}
                            variant="outline"
                            color="gray"
                            className={classNames('rounded-e-none', {
                                '!bg-gray-50': sortBy === 'Nearest',
                            })}
                        >
                            Sort by nearest
                        </Button>
                        <Button
                            onClick={() => setSortBy('Earliest')}
                            variant="outline"
                            color="gray"
                            className={classNames('rounded-s-none border-s-0', {
                                '!bg-gray-50': sortBy === 'Earliest',
                            })}
                        >
                            Sort by earliest
                        </Button>
                    </div>
                </div>
                <SearchResults
                    className="mt-4"
                    query={telehealthQuery}
                    usePriorityWarning={sortBy === 'Nearest'}
                    onClick={async (_timeSlot) => {
                        // const mom = moment(`${timeSlot.slot}`);
                        // await openApp(
                        //     timeSlot.siteId,
                        //     timeSlot.userId,
                        //     mom.toDate(),
                        //     timeSlot.appointmentTypeId,
                        //     "new",
                        //     {
                        //         time: timeSlot.slotTime,
                        //         duration: timeSlot.duration.toString(),
                        //     },
                        //     { timeslotId: timeSlot.id }
                        // )
                    }}
                />
            </div>
        </main>
    );
}
